'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _darken = require('../internal/darken');

var _darken2 = _interopRequireDefault(_darken);

var _fade = require('../internal/fade');

var _fade2 = _interopRequireDefault(_fade);

var _styles = require('../settings/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  iconButton: {
    backgroundColor: 'transparent',
    borderRadius: '50%',
    border: 0,
    cursor: 'pointer',
    height: '40px',
    outline: 0,
    padding: '8px',
    transition: 'all .3s ease-in-out',
    flexShrink: 0,
    width: '40px',

    ':hover': {
      backgroundColor: (0, _fade2.default)(_colors2.default.black, 0.9)
    },
    ':active': {
      boxShadow: _styles2.default.depthShadows[0]
    }
  },
  button: {
    backgroundColor: _colors2.default.theme,
    border: 0,
    borderRadius: '4px',
    boxShadow: _styles2.default.depthShadows[0],
    color: _colors2.default.white,
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'inherit',
    fontFamily: 'inherit',
    lineHeight: '20px',
    outline: 0,
    padding: '6px 12px',
    transition: 'all .3s ease-in-out',
    flexShrink: 0,

    ':hover': {
      backgroundColor: (0, _darken2.default)(_colors2.default.theme, 0.15)
    },
    ':active': {
      boxShadow: _styles2.default.depthShadows[1]
    }
  },
  inverted: {
    color: _colors2.default.theme,
    backgroundColor: _colors2.default.white,

    ':hover': {
      backgroundColor: (0, _darken2.default)(_colors2.default.white, 0.15)
    },
    ':active': {
      boxShadow: _styles2.default.depthShadows[1]
    }
  },
  disabled: {
    opacity: '0.5'
  },
  flatButton: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    textTransform: 'uppercase',
    flexShrink: 0,

    ':hover': {
      backgroundColor: (0, _fade2.default)(_colors2.default.black, 0.95)
    },
    ':active': {
      backgroundColor: (0, _fade2.default)(_colors2.default.black, 0.85)
    }
  }
};
module.exports = exports.default;